import { TaxResidency } from '__generated__/GQL';
import { TranslatedCountry } from 'common/countries/types';

import { InformationSectionItem } from '../../components/InformationSection';
import {
  incomeRangeChoices,
  personalAssetsChoices,
} from '../../modules/Compliance/pages/ComplianceForm/complianceProperties';
import { locales } from './locales';

export const formatComplianceInformationItems = (
  complianceValues: Partial<{
    incomeRange: string;
    isSpecifiedUSPerson: boolean;
    personalAssets: string;
  }>,
  taxResidencies: Pick<TaxResidency, 'country' | 'fiscalId'>[],
  countriesOptions: TranslatedCountry[],
) => {
  const { incomeRange, isSpecifiedUSPerson, personalAssets } = complianceValues;

  const getTaxResidenciesValues = () => {
    return taxResidencies.map((taxResidency) => {
      const { country, fiscalId } = taxResidency || {};

      const matchingCountry = countriesOptions.find(
        (countryOption) => countryOption.value === country,
      );

      return {
        countryLabel: matchingCountry
          ? `${matchingCountry.emoji} ${matchingCountry.label}`
          : '',
        fiscalId,
      };
    });
  };

  const [primaryTaxResidency, secondaryTaxResidency] =
    getTaxResidenciesValues();

  const getIsSpecifiedUSPersonString = (): string => {
    if (isSpecifiedUSPerson === undefined) {
      return '';
    }

    return isSpecifiedUSPerson ? locales.yes : locales.no;
  };

  const isSpecifiedUSPersonString = getIsSpecifiedUSPersonString();

  const personalAssetsString = personalAssetsChoices.find(
    (choice) => choice.value === personalAssets,
  )?.label;
  const incomeRangeString = incomeRangeChoices.find(
    (choice) => choice.value === incomeRange,
  )?.label;

  const complianceInformationItems: InformationSectionItem[] = [
    [locales.assets, personalAssetsString ?? null],
    [locales.income, incomeRangeString ?? null],
    [locales.usCitizen, isSpecifiedUSPersonString],
    [locales.fiscalResidence, primaryTaxResidency?.countryLabel ?? ''],
    [locales.fiscalId, primaryTaxResidency?.fiscalId ?? null],
  ];

  const secondaryComplianceInformationItems: InformationSectionItem[] = [
    [locales.otherFiscalResidence, secondaryTaxResidency?.countryLabel ?? null],
    [locales.fiscalId, secondaryTaxResidency?.fiscalId ?? null],
  ];

  return {
    complianceInformationItems,
    secondaryComplianceInformationItems,
  };
};
